'use strict';
const angular = require('angular');

/*@ngInject*/
export function SurveyResultsService($resource) {
  return $resource('/api/survey-results/:id', {
    name: '@_id'
  },{
    getBySurvey: {
      method: 'GET',
      url: "/api/survey-results/survey/:id",
      isArray: true
    },
    checkParticipation: {
      method: 'GET',
      url: "/api/survey-results/survey/:surveyId/:propertyId"
    }
  });
}


export default angular.module('conduu.SurveyResultsService', [])
  .factory('SurveyResultsService', SurveyResultsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/survey-results/survey-results.service.js